(function () {
  const root = document.querySelector('[data-blog-aqt-aggregate]');
  if (!root) return;

  const btn = root.querySelector('[data-blog-aqt-load-more]');
  const list = root.querySelector('[data-blog-aqt-articles-list]');
  if (!btn || !list) return;

  btn.addEventListener('click', async () => {
    const nextPage = parseInt(btn.dataset.nextPage, 10);
    const totalPages = parseInt(btn.dataset.totalPages, 10);
    if (!nextPage || btn.getAttribute('aria-busy') === 'true') return;

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    try {
      const sectionId = list.id.replace('BlogAqtArticles-', '');
      const url = `${window.location.pathname}?page=${nextPage}&section_id=${sectionId}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(res.statusText);

      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newItems = doc.querySelectorAll('[data-blog-aqt-articles-list] > li');

      const firstNewItem = newItems[0];
      newItems.forEach((li) => list.appendChild(li));

      if (firstNewItem) {
        const focusTarget = firstNewItem.querySelector('a, h3 a, button');
        if (focusTarget) focusTarget.focus();
      }

      const next = nextPage + 1;
      if (next > totalPages) {
        btn.closest('.blog-listing-aqt__pager')?.remove();
      } else {
        btn.dataset.nextPage = next;
      }
    } catch (e) {
      console.error('Load more failed:', e);
    } finally {
      btn.setAttribute('aria-busy', 'false');
      btn.disabled = false;
    }
  });
})();
